import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-data-dashboard-liveclass',
  templateUrl: './no-data-dashboard-liveclass.component.html',
  styleUrls: ['./no-data-dashboard-liveclass.component.css']
})
export class NoDataDashboardLiveclassComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
